import type { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { WA_GREEN } from "@/utils/whatsapp";

export function WaDialog({ open, onClose, title, subtitle, icon, testid, children }: {
    open: boolean; onClose: () => void; title: ReactNode; subtitle?: ReactNode; icon: ReactNode; testid: string; children: ReactNode;
}) {
    const { t } = useTranslation();
    return (
        <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 data-[state=open]:animate-in data-[state=open]:fade-in-0" style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}>
                    <Dialog.Content data-testid={testid} aria-describedby={undefined} onClick={(e) => e.stopPropagation()}
                        className="relative w-full max-w-lg max-h-[92vh] overflow-y-auto rounded-2xl border shadow-2xl outline-none data-[state=open]:animate-in data-[state=open]:zoom-in-95"
                        style={{ background: "var(--card)", borderColor: "var(--border)" }}>
                        <div className="h-1 w-full" style={{ background: WA_GREEN }} />
                        <div className="p-5 sm:p-6">
                            <div className="flex items-start gap-3 mb-5">
                                <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl" style={{ background: `${WA_GREEN}1f`, color: WA_GREEN }}>{icon}</div>
                                <div className="flex-1 min-w-0">
                                    <Dialog.Title className="text-lg font-semibold" style={{ color: "var(--text)" }}>{title}</Dialog.Title>
                                    {subtitle && <div className="text-sm mt-0.5" style={{ color: "var(--text-muted)" }}>{subtitle}</div>}
                                </div>
                                <Dialog.Close aria-label={t("common.close")} data-testid={`${testid}-close`} className="inline-flex h-8 w-8 items-center justify-center rounded-full transition-colors hover:bg-[var(--input)]" style={{ color: "var(--text-muted)" }}><X size={16} /></Dialog.Close>
                            </div>
                            {children}
                        </div>
                    </Dialog.Content>
                </Dialog.Overlay>
            </Dialog.Portal>
        </Dialog.Root>
    );
}
